import axios from "axios";

const apiUrl = process.env.REACT_APP_API_PGIURL;

const PGIservice = {
  async details(id) {
    try {
      const result = await axios.get(`${apiUrl}/index/` + id);
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async formations(id, form) {
    try {
      const result = await axios.post(`${apiUrl}/insertformation/` + id, form, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async updateFormations(id, form) {
    try {
      console.log("formzzza:", form);

      const formDataToSend = new FormData();
      Object.keys(form).forEach((key) => {
        formDataToSend.append(key, form[key]);
      });

      const result = await axios.post(
        `${apiUrl}/updateformation/` + id,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async updateCompetence(id, form) {
    try {
      const result = await axios.post(
        `${apiUrl}/updatecompetences/` + id,
        form
      );
      return result.data;
    } catch (error) {
      if (error.response) {
        return error.response.data;
      } else {
        throw error;
      }
    }
  },
  async deleteformation(id, ref) {
    try {
      const result = await axios.get(
        `${apiUrl}/formationdelete/` + id + `/` + ref
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
export default PGIservice;
